import { DealerChangeLogItemViewForm } from "src/app/features/DealerChangeLog/components/forms/DealerChangeLogItemViewForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const DealerChangeLogItemViewPage = () => {
    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.dealerChangeLogItemFormPage" />
                <ActionBar>
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.DEALER_CHANGE_LOGS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <DealerChangeLogItemViewForm />
            </FPageContent>
        </FPage>
    );
};
